/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 캘린더 관련 API 모음
 * 버전 : 1.0
 * 파일명 : Recruit.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================
 * 수정일 : 2026-02-03, 축제 삭제 API 추가, 축제 정보 받는 API 추가
 * 수정일 : 2026-02-04, 축제 등록 API 추가, 지역 축제 소식 API 추가
 * ================================================================ */

import axios from 'axios'
import { getAuthToken } from './Auth'

const API_URL = process.env.REACT_APP_API_URL

export interface getArmyRecruitParams{
    year : number,
    month : number,
    limit_cnt? : number
}

export const getArmyRecruit = async ({year,month,limit_cnt}:getArmyRecruitParams)=>{
    try{
        const token = getAuthToken()
        
        const response = await axios.get(`${API_URL}/army-recruit-v2`,{
            params:{
                year: year,
                month : month,
                limit_cnt : limit_cnt
            },
            headers:{
                'Content-Type' : 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            return response.data
        }
        catch(error){
        if(axios.isAxiosError(error)){
            if(error.response){
                const response = error.response
                return response.data
            }
        }
    } 
}

type getEventInfoType = {
    year: number,
    month: number,
    limit_cnt? : number
}

export const getEventInfo = async ({year,month,limit_cnt=50}:getEventInfoType)=>{
    try{
        const token = getAuthToken()
        const response = await axios.get(`${API_URL}/event-info`,{
            params:{
                year,
                month,
                limit_cnt: limit_cnt
            },
            headers:{
                Authorization: `Bearer ${token}`
            }
        })
        return response.data
    }
    catch(error){
        if(axios.isAxiosError(error)){
            if(error.response){
                const response = error.response
                return response.data
            }
        }
    } 
}

type postEventInfoBody = {
    name: string,
    type: string,
    start_Date: string | Date | null,
    end_Date: string | Date |null,
    location: string,
    url: string,
    event_id?:number
}

export const postEventInfo = async ({name, type, start_Date, end_Date, location, url, event_id}:postEventInfoBody)=>{
    try{
        const token = getAuthToken()
        const response = await axios.post(`${API_URL}/event-info`,{
            name,
            type,
            start_Date,
            end_Date,
            location,
            url,
            ...(event_id ? { event_id } : {})
        },{
            headers:{
                Authorization: `Bearer ${token}`
            }
        })
        return response.data
    }
    catch(error){
        if(axios.isAxiosError(error)){
            if(error.response){
                const response = error.response
                return response.data
            }
        }
    } 
}

export const deleteEventInfo = async (event_id : number)=>{
    try{
        const token = getAuthToken()
        const response = await axios.delete(`${API_URL}/event-info`,{
            params:{
                event_id
            },
            headers:{
                Authorization: `Bearer ${token}`
            }
        })
        return response.data
    }
    catch(error){
        if(axios.isAxiosError(error)){
            if(error.response){
                const response = error.response
                return response.data
            }
        }
    } 
}

export const getEventInfoFeature = async ()=>{
    try{
        const token = getAuthToken()
        const response = await axios.get(`${API_URL}/event-info/featured`,{
            headers:{
                Authorization: `Bearer ${token}`
            }
        })
        return response.data
    }
    catch(error){
        if(axios.isAxiosError(error)){
            if(error.response){
                const response = error.response
                return response.data
            }
        }
    } 
}